// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import App from "App";
import { UserProviderWrapper } from "context/UserContext"; // Import the wrapper

import "index.css";
import "styles/custom.css";
import "styles/globals.css";
import "styles/bootstrap-custome.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <UserProviderWrapper>
    <App />
  </UserProviderWrapper>
);
